<script setup lang="ts">
import { ref, watch, onMounted } from "vue";
import { Permission } from "../../../../../types/auth";
import PhotosForm from "./PhotosForm.vue";
import ImageGrid from "./ImageGrid.vue";
import SectionTemplate from "./SectionTemplate.vue";
import Buttons from "../../../../../components/ui/form/Buttons.vue";

const props = defineProps<{
  data?: any | [];
  permissions?: Permission[];
  item?: any | null;
}>();

const endPoint = "/clients/inventory/item-management/items/photo-";
const title = "Photos";
const selectedData = ref<any | null>(null);
const showForm = ref(false);
const formMode = ref<
  "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
>("view");

const rows = ref<any[]>(props.data);

const handleCreate = () => {
  selectedData.value = null;
  formMode.value = "create";
  showForm.value = true;
};

const handleSave = (data: any) => {
  console.log(data)
  rows.value = data.photos;
};

const handleRemove = (data: any) => {
  rows.value = data;
};

onMounted(() => {
  rows.value = props.data;
});

watch(
  () => props.data,
  () => {
    rows.value = props.data;
  },
  { immediate: true }
);
</script>

<template>
  <SectionTemplate :title="title" :showQuickTour="false">
    <template #header-actions>
      <Buttons icon="Plus" caption="New Photo" @click="handleCreate" />
    </template>
    <template #main>
      <ImageGrid
        :images="rows"
        :columns="3"
        :gap="8"
        @removed="handleRemove"
        :item="item"
        :rounded="true"
        :show-caption="true"
        :clickable="true"
        aspect-ratio="16/9"
        imageField="path"
        captionField="caption"
      />
    </template>
  </SectionTemplate>
  <PhotosForm
    :permissions="permissions"
    v-if="showForm"
    :item="item"
    :data="selectedData"
    :end-point="endPoint"
    :title="title"
    :mode="formMode"
    @save="handleSave"
    @close="showForm = !showForm"
  />
</template>
